export const ATLAS_AUTH_INFO_LOCAL_STORAGE_KEY = "atlas-auth-info";
